import { render, staticRenderFns } from "./integralGoodsReturn.vue?vue&type=template&id=c6d309d2&scoped=true&"
import script from "./integralGoodsReturn.vue?vue&type=script&lang=js&"
export * from "./integralGoodsReturn.vue?vue&type=script&lang=js&"
import style0 from "./integralGoodsReturn.vue?vue&type=style&index=0&id=c6d309d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d309d2",
  null
  
)

export default component.exports